import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQuery } from '@react-hook/media-query';
import { mediaQuery } from '@modernhealth/vital-foundation';
import { HeadingText20, HeadingText30 } from '../Typography/Typography';
import { Icon } from '../Icon/Icon';
import * as styles from './DeprecatedInlineMessage.module.scss';
export const Heading = ({ heading, icon, startIconUrl, iconColor, }) => {
    const smallScreenDetected = useMediaQuery(mediaQuery.maxWidth('md', true));
    const TextComponent = smallScreenDetected ? HeadingText20 : HeadingText30;
    const renderIcon = () => {
        if (icon) {
            return _jsx(Icon, { name: icon, color: iconColor, size: 16 });
        }
        if (startIconUrl) {
            return _jsx("img", { className: styles.iconImage, src: startIconUrl, alt: "" });
        }
        return _jsx(_Fragment, {});
    };
    return (_jsxs("div", { className: styles.headingContainer, children: [(icon || startIconUrl) && (_jsx("div", { className: styles.iconContainer, children: renderIcon() })), _jsx(TextComponent, { marginTop: 2, marginBottom: 2, fontColor: "gray65", children: heading })] }));
};
